 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"framework","1":"a93780ed92571092093097dde73379f9ef7d599d","2":"d2f59b09","3":"styles","4":"c1faaac332624f8ae46f1093811d9f3da2e0bf89","5":"47345b59b6af457bc6e65f980638d6045ba7e0d7","6":"ecdbd6d17b192dc31b352f13570f76ea0aa209f3","7":"8a9fa39fb9c112f543cf597c2807009add6c6361","8":"07a93e9fa6f186cb4a6b591b9e7487e44c0b6794","9":"393a9b4a6cd257a9c8d982aa7b1ae2a684440562","10":"51b6d7d38ca1cb623b943d9ffdcf96c58eaaf90b","11":"0726c8c89e826da5b8efe9b7358f3d71e48c956d","12":"175960c953b1749ec153d09a5ae1e820f65a3ab1","13":"360598c3b9de8c75c78e8903c25217ecd4f24796","14":"69156681be6cb549f908493f415f8c17f3caa729","15":"a7e9da314421bac5b70893d2b748b7f6de9308b7","16":"e5388504105052777d95c8df40018c0354e2c83e","17":"e63bcaa8eac08d433956145a9e535189a1237fd9","18":"f04c0fc40f52c885d025cdca2cf4dd5a1b756c48","21":"component---src-pages-404-js","22":"component---src-pages-about-de-js","23":"component---src-pages-about-en-js","24":"component---src-pages-career-de-js","25":"component---src-pages-career-en-js","26":"component---src-pages-contact-de-js","27":"component---src-pages-contact-en-js","28":"component---src-pages-data-privacy-de-js","29":"component---src-pages-data-privacy-en-js","30":"component---src-pages-experties-corporate-identity-de-js","31":"component---src-pages-experties-corporate-identity-en-js","32":"component---src-pages-experties-user-experience-de-js","33":"component---src-pages-experties-user-experience-en-js","34":"component---src-pages-experties-video-animation-de-js","35":"component---src-pages-experties-video-animation-en-js","36":"component---src-pages-experties-web-mobile-de-js","37":"component---src-pages-experties-web-mobile-en-js","38":"component---src-pages-expertise-de-js","39":"component---src-pages-expertise-en-js","40":"component---src-pages-faq-en-js","41":"component---src-pages-impressum-en-js","42":"component---src-pages-index-de-js","43":"component---src-pages-index-en-js","44":"component---src-pages-index-js","45":"component---src-pages-news-de-js","46":"component---src-pages-news-en-js","47":"component---src-pages-projects-de-js","48":"component---src-pages-projects-en-js","49":"component---src-pages-thank-you-de-js","50":"component---src-pages-thank-you-en-js","51":"component---src-templates-news-template-js"}[chunkId]||chunkId) + "-" + {"0":"b3520292a8d482714e22","1":"0dd8616ac7b1127323cc","2":"87572661a1de77f2da46","3":"474c0340beb1ced255f1","4":"e77ba3017c5ca358a924","5":"f9152288a839366cefaa","6":"1dce371211c2f0746b65","7":"e16f7bbccc7b2b058c7a","8":"e704aa02527b10206c47","9":"1ada48130dfa880a63d6","10":"06360d4d26d6c11d388c","11":"3d719e0ec30a27924b60","12":"355b29c29537ee5a47e1","13":"5a4bed936884c26e3b07","14":"f8eca30db2b2fea689d5","15":"33a0cf27901dc559eaa7","16":"ee09272fdec5f4091624","17":"9702a187921581da52bf","18":"e869ad60d9190dade344","21":"1e6b43274fee5534dc12","22":"66fbfc9dc28a0d863bda","23":"5da9dcc827fff0b01fb4","24":"df0e3b80fa42403e7efb","25":"2ce31cc0b93121984b03","26":"d18724dc1d432528678d","27":"1e9f22d2a16e9343fd69","28":"6e6ad43b555ff76f9b66","29":"40a95e1fbb0a0fa57785","30":"d13db57875f104debd7d","31":"f50f5b71319834944b70","32":"a1b60fef6831781b6dfb","33":"a7d87ced67e8da8a8ca1","34":"4ed878f378a5b68a856c","35":"1b3dccab8002ec228b95","36":"3862413005f857a0db91","37":"ca69b744a139281727df","38":"1a729599785c71257757","39":"d9c79fa2d587a5d6d151","40":"9b38deab9ea49ae4db32","41":"750a0e3f3a1579be7638","42":"ddfc5ae438125d3f8ea8","43":"926ffc0a765ca767729b","44":"3052a0b09c4121f2f5b8","45":"d8965e4afdf5f14421ff","46":"68368321efe7260db21a","47":"02fd5685c28b8a9ac6f7","48":"af7fb31eb84cccb77dc0","49":"fe6725e40fce727134dd","50":"5381fce257bc28308adf","51":"fde246d88af01d7b6a64"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"framework","1":"a93780ed92571092093097dde73379f9ef7d599d","2":"d2f59b09","3":"styles","4":"c1faaac332624f8ae46f1093811d9f3da2e0bf89","5":"47345b59b6af457bc6e65f980638d6045ba7e0d7","6":"ecdbd6d17b192dc31b352f13570f76ea0aa209f3","7":"8a9fa39fb9c112f543cf597c2807009add6c6361","8":"07a93e9fa6f186cb4a6b591b9e7487e44c0b6794","9":"393a9b4a6cd257a9c8d982aa7b1ae2a684440562","10":"51b6d7d38ca1cb623b943d9ffdcf96c58eaaf90b","11":"0726c8c89e826da5b8efe9b7358f3d71e48c956d","12":"175960c953b1749ec153d09a5ae1e820f65a3ab1","13":"360598c3b9de8c75c78e8903c25217ecd4f24796","14":"69156681be6cb549f908493f415f8c17f3caa729","15":"a7e9da314421bac5b70893d2b748b7f6de9308b7","16":"e5388504105052777d95c8df40018c0354e2c83e","17":"e63bcaa8eac08d433956145a9e535189a1237fd9","18":"f04c0fc40f52c885d025cdca2cf4dd5a1b756c48","21":"component---src-pages-404-js","22":"component---src-pages-about-de-js","23":"component---src-pages-about-en-js","24":"component---src-pages-career-de-js","25":"component---src-pages-career-en-js","26":"component---src-pages-contact-de-js","27":"component---src-pages-contact-en-js","28":"component---src-pages-data-privacy-de-js","29":"component---src-pages-data-privacy-en-js","30":"component---src-pages-experties-corporate-identity-de-js","31":"component---src-pages-experties-corporate-identity-en-js","32":"component---src-pages-experties-user-experience-de-js","33":"component---src-pages-experties-user-experience-en-js","34":"component---src-pages-experties-video-animation-de-js","35":"component---src-pages-experties-video-animation-en-js","36":"component---src-pages-experties-web-mobile-de-js","37":"component---src-pages-experties-web-mobile-en-js","38":"component---src-pages-expertise-de-js","39":"component---src-pages-expertise-en-js","40":"component---src-pages-faq-en-js","41":"component---src-pages-impressum-en-js","42":"component---src-pages-index-de-js","43":"component---src-pages-index-en-js","44":"component---src-pages-index-js","45":"component---src-pages-news-de-js","46":"component---src-pages-news-en-js","47":"component---src-pages-projects-de-js","48":"component---src-pages-projects-en-js","49":"component---src-pages-thank-you-de-js","50":"component---src-pages-thank-you-en-js","51":"component---src-templates-news-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"bff12de2478449c64183","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
